import { useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { cn } from "@/utils/cn";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { trackPageView } from "@/lib/analytics";

const tabs = [
  { label: "Important Dates", href: "/settings/important-dates" },
  { label: "User Management", href: "/settings/user-management" }
] as const;

export function SettingsPage() {
  const currentUser = useCurrentUser();
  const userId = currentUser?.email ?? "Unknown";

  // Track page view on mount
  useEffect(() => {
    trackPageView("Settings", userId);
  }, [userId]);

  return (
    <section className="dashboard">
      <div className="border-b border-slate-200" role="tablist" aria-label="Settings tabs">
        {tabs.map((tab) => (
          <NavLink
            key={tab.href}
            to={tab.href}
            className={({ isActive }) =>
              cn(
                "inline-flex px-4 py-2 text-sm font-medium border-b-2 -mb-px focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-700",
                isActive
                    ? "border-black bg-black text-white font-semibold"
                  : "border-transparent text-slate-600 hover:text-slate-900"
              )
            }
            role="tab"
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <div className="pt-4">
        <Outlet />
      </div>
    </section>
  );
}
